// 测试环境模板的数据地址 https://test.allflow.cn/4ebb17ef-d747-471d-9c28-4363d4522749
// 下面是表头对应的字段。
import { useAppTranslation } from '@flowus/common/i18n/use-translation';

export const useTemplateConsts = () => {
  const { t } = useAppTranslation();
  return {
    TEMPLATE_CATEGORY: t('hooks.template.template_category'),
    ONE_STAGE_CATEGORY: t('hooks.template.one_stage_category'),
    TWO_STAGE_CATEGORY: t('hooks.template.two_stage_category'),
    THREE_STAGE_CATEGORY: t('hooks.template.three_stage_category'),
    TEMPLATE_HOME_PAGE_TOP: t('hooks.template.home_page_top'),
    TEMPLATE_NAME: t('hooks.template.template_name'),
    TEMPLATE_LINK: t('hooks.template.template_link'),
    TEMPLATE_SOURCE: t('hooks.template.template_source'),
    TEMPLATE_SOURCE_IMAGE: t('hooks.template.source_image'),
    TEMPLATE_IMAGE: t('hooks.template.template_image'),
    TEMPLATE_RELEASE: t('common.publish'),
    TEMPLATE_DESC: t('hooks.template.template_desc'),
    TEMPLATE_URL: t('hooks.template.template_url'),
    TEMPLATE_RECOMMEND_TAG: t('hooks.template.recommend_tag'),
    TEMPLATE_EMPTY_RECOMMEND_TAG: t('hooks.template.empty_recommend_tag'),
  };
};
// 下面的文本不要翻译
// Legacy exports for backward compatibility
export const TEMPLATE_CATEGORY = '模板类别';
export const ONE_STAGE_CATEGORY = '一级分类';
export const TWO_STAGE_CATEGORY = '二级分类';
export const THREE_STAGE_CATEGORY = '三级分类';
export const TEMPLATE_HOME_PAGE_TOP = '首页置顶';
export const TEMPLATE_NAME = '模板名称';
export const TEMPLATE_LINK = '模板链接';
export const TEMPLATE_SOURCE = '模板来源';
export const TEMPLATE_SOURCE_IMAGE = '模板来源配图';
export const TEMPLATE_IMAGE = '模板介绍配图';
export const TEMPLATE_RELEASE = '上线';
export const TEMPLATE_DESC = '模板介绍';
export const TEMPLATE_URL = '模板链接';
export const TEMPLATE_RECOMMEND_TAG = '推荐标签';
export const TEMPLATE_EMPTY_RECOMMEND_TAG = '空白推荐';
